import ViewRetailer from "../../../../components/@users/retailers/ViewRetailer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailerViewPage() {

    return (
        <ViewRetailer 
            routeType={routeTypes.admin}
        />
    )
}       